import { useCallback, useMemo } from 'react';
import UniversalAssociationsSelectOption from './UniversalAssociationsSelectOption';
import UniversalAssociationsSelectOptionHeader from './UniversalAssociationsSelectOptionHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalAssociationsSelectOptions = ({
  associationRecord,
  canEdit,
  emailRecipientsIds,
  engagementOrInteractionType,
  onToggleSelectAssociation,
  readOnly,
  searchText,
  selectedObjectTypeId,
  shouldDisableLastAssociation
}) => {
  const pluralObjectName = associationRecord.get('pluralObjectName');
  const shouldShowObjectTypeHeader = !selectedObjectTypeId;
  const handleToggleSelect = useCallback(associationOptionRecord => {
    onToggleSelectAssociation(associationRecord, associationOptionRecord);
  }, [associationRecord, onToggleSelectAssociation]);
  const AssociationSelectOptions = useMemo(() => {
    return associationRecord.get('associationOptionRecords').map(associationOptionRecord => {
      const objectId = associationOptionRecord.get('objectId');
      return /*#__PURE__*/_jsx(UniversalAssociationsSelectOption, {
        associationOptionRecord: associationOptionRecord,
        canEdit: canEdit,
        emailRecipientsIds: emailRecipientsIds,
        engagementOrInteractionType: engagementOrInteractionType,
        onToggleSelectAssociation: handleToggleSelect,
        readOnly: readOnly,
        searchText: searchText,
        shouldDisableLastAssociation: shouldDisableLastAssociation,
        toObjectTypeId: associationRecord.get('toObjectTypeId')
      }, `universal-associations-select-${objectId}`);
    }).valueSeq();
  }, [associationRecord, canEdit, emailRecipientsIds, engagementOrInteractionType, handleToggleSelect, readOnly, searchText, shouldDisableLastAssociation]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldShowObjectTypeHeader && /*#__PURE__*/_jsx(UniversalAssociationsSelectOptionHeader, {
      pluralObjectName: pluralObjectName
    }, `${pluralObjectName}-associations-option-header`), AssociationSelectOptions]
  });
};
export default UniversalAssociationsSelectOptions;